import { useTimeRangePopulator } from 'hooks';
import usePayPeriodTimeRangeGet from './usePayPeriodTimeRangeGet';
import { LuxonZone } from 'types/LuxonZone';

export default function usePayPeriodPopulator(zone: LuxonZone) {
  const getter = usePayPeriodTimeRangeGet(zone);
  return useTimeRangePopulator(getter);
}
